import styled from 'styled-components';
import breakpoints from '../../../breakpoints';

export default styled.div`
  height: 450px;
  width: 450px;
  border-radius: 50%;
  background-image: ${({ imageUrl }) => `url(${imageUrl})`};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  @media (max-width: ${breakpoints.xs}), (max-height: ${breakpoints.macbookHeight}) {
    height: 320px;
    width: 320px;
  }
`;
